import { fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const SET_MAINTENANCE_MODE = 'maintenance/SET_MAINTENANCE_MODE'

// action
export const setMaintenanceMode = ActionHelper.createActionObj(
  SET_MAINTENANCE_MODE,
)

// state
const initialState = fromJS({
  maintenanceMode: false,
})

// reducers
const maintenance = handleActions(
  {
    [SET_MAINTENANCE_MODE]: (state, action) =>
      state.set('maintenanceMode', action.payload),
  },
  initialState,
)

export default maintenance
